<div class="page-title-area"  >
  <div class="d-table">
      <div class="d-table-cell">
          <div class="container">
              <div class="page-title-text">
               
               
                  <ul>
                      <li><a routerLink="/job-list">Dashboard</a></li>

          
                      <li><i class="icofont-simple-right"></i></li>
                      <li>Upload CV</li>
                  </ul>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="dashboard-area pt-100" >
    <div class="container">
        <div class="row align-items-center">
         <div class="col-lg-12">
                <div class="dashboard-img">
                   <!--- <img src="assets/img/dashboard/1.jpg" alt="Dashboard"> -->
                 
                    
                </div>
            </div>
       

            <app-dashpills></app-dashpills>

        </div>
        <div class="row">
          <div class="col-lg-6" style="margin:0 auto;">
            <div class="create-information text-center" *ngIf="hasCv">
              <h3>Bo Dokumento</h3>
              <a href="{{ cvUrl }}" target="_blank" class="text-black"><i class="icofont-file-pdf text-danger"></i><u>Download Dokumento</u></a>
            </div>
          </div>
        </div>


<div class="row">
<div class="col-lg-6" style="margin:0 auto;">
    <div class="create-information text-center" >
        <h3>Upload bo CV</h3>
<div class="row">
<div class="col-lg-8" style="margin: 0 auto;">
  <!-- Display selected file name directly -->
  <p *ngIf="fileName">{{ fileName }}</p>
  <p *ngIf="!fileName">No file selected</p>
</div>
<div class="col-lg-4" style="margin: 0 auto;">
  <!-- Choose file button -->
  <input type="file" (change)="onFileSelected($event)" id="cvUpload" accept=".pdf" hidden>
  <label for="cvUpload" class="btn btn-primary btn-block">Choose File</label>
  
</div>
<div class="col-lg-12 mt-4">
  <!-- Upload button beneath the text box and choose file button -->
  <button (click)="uploadCV()" class="btn btn-success btn-block" [disabled]="!selectedFile || fileTypeError || isUploading">
    <span *ngIf="isUploading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
    Upload CV
  </button>
  <!-- Display file type error if any -->
  <div *ngIf="fileTypeError" class="text-danger mt-2">{{ fileTypeError }}</div>
</div>
</div>
</div>
</div>
</div>
        <!-- Basic Information Section -->
